import type { ReactNode } from "react";
import { getBrowserGateVariant } from "../lib/appClient";
import DownloadAppPage from "../pages/DownloadAppPage";
import OpenInAppPage from "../pages/OpenInAppPage";

/** Routes non-native clients to the appropriate gate page; Vite dev bypasses. */
export function BrowserGate({ children }: { children: ReactNode }) {
  switch (getBrowserGateVariant()) {
    case "app":
      return <>{children}</>;
    case "ios-browser":
      return <OpenInAppPage />;
    case "download":
      return <DownloadAppPage />;
  }
}
